import PropTypes from 'prop-types';

import { Button } from '@spotahome/ui-library';

import Section from '../LandingSection';

import './LandingSocialBannerSection.scss';

const noop = () => {};
const LandingSocialBannerSection = ({ title, cta, renderIcon = noop }) => {
  return (
    <Section className="landing-social-banner-section">
      <div className="landing-social-banner-section__content">
        {renderIcon()}
        <h2 className="landing-social-banner-section__title">{title}</h2>
        <Button color="primary" size="large" alt href={cta.url}>
          {cta.text}
        </Button>
      </div>
    </Section>
  );
};

LandingSocialBannerSection.propTypes = {
  title: PropTypes.string.isRequired,
  cta: PropTypes.shape({
    url: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }).isRequired,
  renderIcon: PropTypes.func
};

export default LandingSocialBannerSection;
